import { facilitiesApi } from '@/api/facilitiesApi';
import { useSyncSparefootBidsMutation } from '@/api/portfolioApi';
import LoadingImage from '@/assets/images/old-loading.svg';
import { selectPortfolioId } from '@/features/auth/authSelector';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './Loading.less';

const Loading = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasSyncedRef = useRef(false);
  const portfolioId = useSelector(selectPortfolioId);

  const [syncSparefootBids] = useSyncSparefootBidsMutation();

  useEffect(() => {
    // Wait for portfolioId to be available before syncing
    if (!portfolioId || hasSyncedRef.current) return;

    const executeSync = async () => {
      hasSyncedRef.current = true;
      try {
        await syncSparefootBids(portfolioId).unwrap();
        // Invalidate Facilities and FacilityBids cache
        dispatch(
          facilitiesApi.util.invalidateTags([
            { type: 'Facilities', id: portfolioId },
            { type: 'FacilityBids', id: portfolioId },
          ])
        );
        navigate('/facility-bids');
      } catch (error) {
        console.log(error);
        navigate('/facility-bids');
      }
    };

    executeSync();
  }, [syncSparefootBids, portfolioId, navigate, dispatch]);

  return (
    <div className="loading-container" role="status" aria-live="polite">
      <div className="loading-content">
        <div className="loading-animation">
          <img src={LoadingImage} alt="Loading Animation" className="loading-svg" />
        </div>
        <p className="loading-text">Downloading Zip/City Bid Opportunities From SpareFoot...</p>
      </div>
    </div>
  );
};

export default Loading;
